<script setup lang="ts">
import { DropdownMenuSeparator } from 'reka-ui';
</script>

<template>
    <DropdownMenuSeparator class="my-1 h-px bg-muval-gray-5" />
</template>
